module.exports = __webpack_public_path__ + "img/14.5d0fdc0c.png";